import React, { useRef } from "react";
import {
  CustomText,
  Input,
  InputDate,
  SelectComponent,
} from "../../../components";
import { FormFull } from "form-full";
import { fonts } from "../../../config";

import { masks, validations } from "../../../utils";
import { StylesGuest } from "../styles";
import { FormHelperText, Grid } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import { customModal } from "../../../components/modals/utils";
import WebcamModal from "./WebcamModal";
import { LabelView, MyLabel } from "../../guestHome/GuestHome";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import "../../../phone.css";

function VisitantForm({ data, onSubmit }) {
  const [fileName, setFileName] = React.useState<any>({});
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const fileRef = useRef<any | null>(null);
  const [docType, setDocType] = React.useState<any>(
    data?.secondaryGuests?.cpf ? 1 : data?.secondaryGuests?.passport ? 2 : 1
  );
  const [formRef, setFormRef] = React.useState<any>(null);
  const phone = React.useRef<any>();
  function setPhone(value) {
    phone.current = value;
  }

  React.useEffect(() => {
    // if (data.secondaryGuests?.image) {
    //   setFileName({ base: "GuestImage.png" });
    //   fileRef.current = { base: data.secondaryGuests?.image };
    // }
    if (data.secondaryGuests?.phone) {
      setPhone(data.secondaryGuests?.phone);
    }
  }, [data]);

  // const handleImageChange = () => {
  //   const savePhoto = (fileData: { src: string; name: string }) => {
  //     setFileName({ base: fileData.name });
  //     fileRef.current = { base: fileData?.src };
  //     formRef.submit();
  //   };
  //   customModal.setInfos(
  //     "Cadastro da Facial",
  //     [],
  //     null,
  //     null,
  //     <WebcamModal onSubmit={savePhoto} />,
  //     false,
  //     false
  //   );
  // };

  // const openModalViewImg = () => {
  //   customModal.setInfos(
  //     fileName.base,
  //     [],
  //     {
  //       onClick: () => {
  //         customModal.close();
  //       },
  //       label: "Voltar",
  //     },
  //     null,
  //     <div
  //       style={{
  //         paddingInline: "20px",
  //       }}
  //     >
  //       <div
  //         style={{
  //           borderRadius: "5px",
  //           maxHeight: "80vh",
  //           maxWidth: "80vw",
  //           height: "100%",
  //           width: "400px",
  //           minHeight: "300px",
  //           backgroundRepeat: "no-repeat",
  //           backgroundPosition: "center",
  //           backgroundSize: "contain",

  //           backgroundImage: `url(${fileRef.current.base})`,
  //         }}
  //       />
  //     </div>,
  //     false,
  //     false
  //   );
  // };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={4} xl={5}>
          <StylesGuest.Container>
            <CustomText
              style={{ paddingBottom: "5px" }}
              fontSize={2.25}
              fontFamily={fonts.bold}
              textColor="#4D585A"
            >
              Dados da Estadia
            </CustomText>
            <CustomText
              style={{ paddingBottom: "25px" }}
              fontSize={1.75}
              fontFamily={fonts.regular}
              textColor="#24272A"
            >
              Validação dos dados básicos do visitante do imóvel:
            </CustomText>

            <CustomText
              style={{ paddingBottom: "25px" }}
              fontSize={1.75}
              fontFamily={fonts.bold}
              textColor="#8D9B9C"
            >
              DADOS DO VISITANTE (PRIMÁRIO)
            </CustomText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} lg={12} xl={6}>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={1.75}
                  fontFamily={fonts.semibold}
                  textColor="#4D585A"
                >
                  NOME COMPLETO
                </CustomText>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={2}
                  fontFamily={fonts.semibold}
                  textColor="#24272A"
                >
                  {data?.primaryGuest?.name}
                </CustomText>
                <StylesGuest.Line></StylesGuest.Line>
              </Grid>
              <Grid item xs={12} sm={6} lg={12} xl={6}>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={1.75}
                  fontFamily={fonts.semibold}
                  textColor="#4D585A"
                >
                  Documento
                </CustomText>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={2}
                  fontFamily={fonts.semibold}
                  textColor="#24272A"
                >
                  {data?.primaryGuest?.cpf
                    ? masks.CPF(data?.primaryGuest?.cpf)
                    : data?.primaryGuest?.passport}
                </CustomText>
                <StylesGuest.Line></StylesGuest.Line>
              </Grid>
              <Grid item xs={12} sm={6} lg={12} xl={6}>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={1.75}
                  fontFamily={fonts.semibold}
                  textColor="#4D585A"
                >
                  E-MAIL
                </CustomText>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={2}
                  fontFamily={fonts.semibold}
                  textColor="#24272A"
                >
                  {data?.primaryGuest?.email}
                </CustomText>
                <StylesGuest.Line></StylesGuest.Line>
              </Grid>
              {data?.primaryGuest?.phone ? (
                <Grid item xs={12} sm={12}>
                  <CustomText
                    style={{ paddingBottom: "6px" }}
                    fontSize={1.75}
                    fontFamily={fonts.semibold}
                    textColor="#4D585A"
                  >
                    TELEFONE
                  </CustomText>
                  <CustomText
                    style={{ paddingBottom: "6px" }}
                    fontSize={2}
                    fontFamily={fonts.semibold}
                    textColor="#24272A"
                  >
                    {masks.inputMaskTELWithDDD(data?.primaryGuest?.phone)}
                  </CustomText>
                  <StylesGuest.Line></StylesGuest.Line>
                </Grid>
              ) : (
                <div></div>
              )}
              <FormFull
                formRef={setFormRef}
                onSubmit={(data: any) => {
                  onSubmit({ ...data, ...fileRef });
                }}
              >
                {/* <Grid item xs={12} md={12} lg={12}>
                  <CustomText
                    fontSize={1.75}
                    fontFamily={fonts.semibold}
                    textColor="#4D585A"
                  >
                    CADASTRO DA FACIAL*
                  </CustomText>
                  <StylesGuest.InputImage
                    style={{
                      backgroundColor: "#D39899",
                      borderColor: "red",
                      borderStyle: "solid",
                      borderWidth: "2px",
                    }}
                  >
                    <StylesGuest.InputImageClick htmlFor={"fileInput"}>
                      {fileName?.base ? (
                        <CustomText
                          style={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            display: "block",
                          }}
                          textColor="#4D585A"
                          fontSize={2}
                          fontFamily={fonts.medium}
                        >
                          {fileName?.base}
                        </CustomText>
                      ) : (
                        <CustomText
                          textColor="#4D585A"
                          fontSize={2}
                          fontFamily={fonts.medium}
                        >
                          Clique aqui para cadastrar sua facial
                        </CustomText>
                      )}

                      <button
                        id="fileInput"
                        onClick={() => handleImageChange()}
                        style={{ display: "none" }}
                      ></button>
                    </StylesGuest.InputImageClick>
                    {fileName?.base && (
                      <StylesGuest.InputView
                        endIcon={<Visibility />}
                        fullWidth={false}
                        onClick={() => openModalViewImg()}
                      >
                        Visualizar
                      </StylesGuest.InputView>
                    )}{" "}
                  </StylesGuest.InputImage>{" "}
                  <FormHelperText
                    style={{ color: "#24272A" }}
                    error={false}
                  ></FormHelperText>
                </Grid> */}
                <StylesGuest.ButtonsContainer>
                  <StylesGuest.SendForm
                    //disabled={Object.keys(fileName).length < 1}
                    fullWidth={false}
                    action="submit"
                    style={
                      Object.keys(fileName).length >= 1
                        ? {
                            backgroundColor: "red",
                            borderColor: "red",
                            borderStyle: "solid",
                            borderWidth: "2px",
                          }
                        : {}
                    }
                  >
                    Confirmar dados
                  </StylesGuest.SendForm>
                </StylesGuest.ButtonsContainer>
              </FormFull>
            </Grid>
          </StylesGuest.Container>
        </Grid>
      </Grid>
    </>
  );
}

export default VisitantForm;
